var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleBarImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 216,
    viewBox: "0 0 184 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    r: 89.5384,
    transform: "matrix(-1 0 0 1 136.615 89.5384)",
    fill: "#8282DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.724 215.995H211.385L193.019 138.916C190.933 129.24 181.256 123.039 171.515 125.135L136.626 132.642C126.885 134.739 121.802 143.399 125.33 151.886C128.858 160.373 128.082 171.964 123.605 177.644C119.127 183.323 119.767 191.435 125.024 195.671C129.579 199.341 147.116 207.936 151.724 215.995Z",
    fill: "#C2C2E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.515 125.135L136.625 132.642C132.706 133.486 129.542 135.393 127.389 137.923H192.772C190.26 128.821 180.918 123.112 171.515 125.135Z",
    fill: "#8282DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.158 164.682L195.734 150.315H124.775C124.928 150.838 125.112 151.362 125.329 151.886C126.952 155.788 127.653 160.344 127.514 164.682H199.158Z",
    fill: "#8282DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11 177.073H124.005C123.871 177.263 123.745 177.465 123.604 177.643C120.353 181.767 119.813 187.167 121.766 191.44H205.534L202.11 177.073Z",
    fill: "#8282DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.082 215.991L211.385 216L208.486 203.832H132.262C134.308 207.173 135.853 211.23 136.082 215.991Z",
    fill: "#8282DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.625 132.642C126.884 134.738 121.801 143.398 125.33 151.885C126.495 154.689 127.181 157.831 127.429 160.987L139.537 132.016L136.625 132.642Z",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.901 192.841C126.901 192.841 117.563 194.801 112.368 195.788C107.172 196.775 107.042 200.843 107.042 200.843C107.042 200.843 122.055 197.937 127.933 196.845",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.534 181.917C111.534 181.917 91.4808 186.404 86.3038 187.485C81.1273 188.565 79.4277 184.861 79.4277 184.861C79.4277 184.861 105.083 179.071 110.932 177.827C116.78 176.583 119.891 180.405 121.608 182.648C125.056 187.152 134.563 196.996 134.563 196.996L137.7 196.599C138.031 196.971 138.226 197.417 138.286 197.875L141.089 199.343C132.269 209.497 124.839 203.144 113.957 193.357C110.555 190.297 107.54 186.107 102.566 188.651C97.5916 191.195 103.32 185.958 103.32 185.958L114.37 180.103L122.312 192.543",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2051 190.447L111.108 179.114C112.287 178.495 113.745 178.936 114.37 180.102C114.997 181.27 114.329 182.459 113.153 183.08C113.153 183.08 102.095 189.043 97.3011 191.467C92.507 193.89 90.2051 190.447 90.2051 190.447Z",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.943 196.45H197.666L167.82 145.269C162.997 136.489 166.759 128.122 172.836 125.417C178.912 122.711 187.014 125.414 191.637 134.693L220.968 200.73C224.195 208.423 219.775 216.405 208.72 215.607L130.904 204.365",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.308 113.941C153.34 115.542 150.884 117.037 147.851 117.263L118.651 119.441C115.618 119.667 112.664 117.426 112.088 114.461L104.844 77.2196C104.267 74.2542 106.22 71.2732 109.185 70.5953L142.741 62.9173C145.706 62.2393 148.23 64.1535 148.353 67.1707L149.62 98.5274C149.742 101.545 150.609 105.592 151.547 107.522C152.484 109.451 153.277 112.34 153.308 113.941Z",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.472 104.104C108.196 103.264 104.56 103.723 104.442 102.406C104.316 101.088 108.748 98.2839 108.338 93.9111",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.294 94.629C114.389 95.4894 115.168 96.1043 116.031 96.0037C116.895 95.9102 117.517 95.1456 117.42 94.2829L117.248 92.7301C117.151 91.8792 116.374 91.2572 115.507 91.3554C114.645 91.4536 114.021 92.2226 114.118 93.0786L114.294 94.629Z",
    fill: "#293B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.533 49.678C185.531 49.6498 185.52 49.6269 185.518 49.6018L185.511 49.5435H185.508C184.147 41.2998 175.775 35.7508 166.729 37.1351C158.036 38.4662 151.892 45.7209 152.495 53.6244L152.434 53.6316L155.278 73.007C157.864 89.6413 174.701 100.87 192.886 98.0875L185.544 49.7512C185.538 49.726 185.538 49.7009 185.533 49.678Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.207 105.233C120.857 107.16 119.728 109.267 117.694 109.945C115.654 110.616 113.483 109.606 112.83 107.679L120.207 105.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.371 117.764L140.326 133.713C142.2 138.889 147.944 141.576 153.158 139.717C158.371 137.858 161.078 132.152 159.204 126.977L153.251 111.03L152.353 109.426L134.371 117.764Z",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.53 80.72C126.39 89.9028 127.358 95.3532 136.588 94.5024C139.669 94.2146 141.091 97.3364 143.616 98.8868L153.251 111.03C148.787 98.9754 167.314 91.224 165.991 77.1075C164.665 62.9869 156.638 53.86 142.151 55.2047L121.302 57.122C108.506 58.3099 99.0968 69.5692 100.289 82.2704L100.744 87.1199L133.142 84.1246",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44 95.0825C146.232 99.0508 142.845 101.548 139.882 100.664C136.915 99.7755 135.487 95.8307 136.693 91.858C137.904 87.8897 141.286 85.3806 144.254 86.2738C147.221 87.1674 148.646 91.1049 147.44 95.0825Z",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.043 106.121C148.033 107.708 147.305 109.006 145.425 109.006H136.353C134.473 109.006 133.745 107.708 134.735 106.121L139.089 99.1432C140.079 97.5564 141.699 97.5565 142.689 99.1432L147.043 106.121Z",
    stroke: "#EA444E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.038 189.388C110.038 189.388 106.547 191.399 104.18 194.645C102.72 196.646 101.18 198.773 100.019 200.412C96.9731 204.708 93.186 203.149 93.186 203.149C93.186 203.149 97.1746 198.153 100.431 192.987C103.32 188.403 105.578 188.525 106.787 186.807",
    fill: "#FF9673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.617 184.113L108.294 181.318C108.294 181.318 111.685 179.672 115.68 180.87",
    stroke: "#EA444E",
    strokeWidth: 0.8741,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.055 203.947C126.02 203.285 120.411 199.163 113.957 193.358C111.193 190.872 108.685 187.639 105.173 187.879",
    stroke: "#EA444E",
    strokeWidth: 0.8741,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2005 204.596C27.8964 208.464 32.7589 211.626 37.0065 211.626H122.715C126.963 211.626 129.05 208.464 127.355 204.596L101.744 146.202C100.048 142.337 95.1871 139.173 90.9383 139.173H5.22959C0.982761 139.173 -1.10602 142.337 0.589483 146.202L26.2005 204.596Z",
    fill: "#DFDFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.22958 139.173C0.982834 139.173 -1.10603 142.337 0.589473 146.202L20.2482 191.025L84.2203 139.173H5.22958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.628 211.653C185.628 214.051 183.668 215.994 181.253 215.994H31.8768C29.0713 215.994 29.0713 211.653 31.6295 211.653H185.628Z",
    fill: "#F1F0F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.619 211.653C128.619 214.051 126.66 215.994 124.245 215.994H31.8768C29.0713 215.994 29.0713 211.653 31.6295 211.653H128.619Z",
    fill: "#EFF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8218 183.001C55.2401 179.098 56.9762 174.727 60.6998 173.239C64.4234 171.751 68.7253 173.709 70.3082 177.611C71.8907 181.516 70.155 185.887 66.4314 187.375C62.7078 188.863 58.4047 186.905 56.8218 183.001Z",
    fill: "#C2C2E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 179.077,
    fill: "white",
    transform: "translate(0 36.9233)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBarImage);
export default __webpack_public_path__ + "static/media/title_bar_image.15b03989.svg";
export { ForwardRef as ReactComponent };